import { Constants } from "../../shared/constants/constants";
import { AdaaHelper } from "./adaa-helper";

export const getPlanRevId = () => {
  const revId = AdaaHelper.getLocalStorage(Constants.localStorageKeys.currentPlan, {
    property: "dataRevisionId",
    type: "prop",
  });

  return +revId;
};

const getRevIdByPlanId = (planId: number) => {
  switch (+planId) {
    case 233:
    case 234:
    case 235:
    case 236:
      return 1;
    case 237:
      return 2;
    case 238:
    default:
      return 3;
  }
};

export const isDsV1 = (planId?: number) => {
  if (planId) return getRevIdByPlanId(planId) === 1;

  return getPlanRevId() === 1;
};

export const isDsV2 = (planId?: number) => {
  if (planId) return getRevIdByPlanId(planId) === 2;

  return getPlanRevId() === 2;
};

export const isDsV3 = (planId?: number) => {
  if (planId) return getRevIdByPlanId(planId) === 3;

  return getPlanRevId() === 3;
};
